import { PropsWithChildren } from 'react'
import Styles from './Sections.module.scss'
export const Sections = ({ children }: PropsWithChildren) => <div className={Styles.sections}>{children}</div>
